module.exports = __webpack_public_path__ + "static/img/wireframe-img-03@w.d7a74dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/wireframe-img-03@w.png
// module id = MV59
// module chunks = 0